import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["counter"]
  
  connect() {
    this.elapsedTime = 0
    this.startCounter()
  }

  disconnect() {
    if (this.interval) {
      clearInterval(this.interval)
    }
  }

  startCounter() {
    this.interval = setInterval(() => {
      this.elapsedTime += 0.01
      this.counterTarget.textContent = `${this.elapsedTime.toFixed(2)}s`
    }, 10)
  }
} 